import classnames from 'classnames';
import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import React from 'react';

const Input = ({
    helpText,
    children,
    id,
    extraClass,
    name,
    type,
    isRequired,
    inputIcon,
    small,
    medium,
    large,
    fullWidth,
    fullWidthWithBtn,
    label,
    placeholder,
    value,
    onChangeHandler,
    onClickHandler,
    onBlurHandler,
    readOnly,
    error,
    success,
    helper
}) => {
    const inputClass = classnames('form-field', extraClass, {
        'is-required': isRequired,
        'small': small,
        'medium': medium,
        'large': large,
        'full-width': fullWidth,
        'full-width-with-btn': fullWidthWithBtn,
        'is-invalid': error,
        'is-valid': success,
        'has-helper': helper
    });

    return (
        <div className={inputClass}>
            <div className="input-container">
                {(label || isRequired) && <label className="label" htmlFor={id}>{label}</label>}
                <div className="input-wrapper" onClick={onClickHandler}>
                    <input
                        className="input"
                        type={type}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        readOnly={readOnly} />
                    {inputIcon && <Icon name={inputIcon} />}
                </div>
                {helpText && <p className="help-text">{helpText}</p>}
                {children}
            </div>
            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}
            {helper && <p className="helper-message">{helper}</p>}
        </div>
    );
};

Input.defaultProps = {
    type: 'text',
    extraClass: '',
    placeholder: '',
    isRequired: false,
    small: false,
    medium: false,
    large: false,
    fullWidth: false,
    fullWidthWithBtn: false,
    readOnly: false,
    inputIcon: null,
    error: '',
    success: '',
    helper: '',
    // eslint-disable-next-line no-empty-function
    onChangeHandler: () => {},
    // eslint-disable-next-line no-empty-function
    onBlurHandler: () => {},
    // eslint-disable-next-line no-empty-function
    onClick: () => {}
};

Input.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    id: PropTypes.string.isRequired,
    extraClass: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    isRequired: PropTypes.bool,
    inputIcon: PropTypes.string,
    small: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,
    fullWidth: PropTypes.bool,
    fullWidthWithBtn: PropTypes.bool,
    label: PropTypes.string,
    helpText: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func,
    onClickHandler: PropTypes.func,
    onBlurHandler: PropTypes.func,
    readOnly: PropTypes.bool,
    error: PropTypes.string,
    success: PropTypes.string,
    helper: PropTypes.string
};

export default Input;
